// File generated by PostBuildApiClientController
import { HttpApiClient } from "./HttpApiClient";
import { HttpApiRequestOptions } from "./HttpApiRequestOptions";
import { Injectable } from "@angular/core";
import { ClientUsersAdminDto } from "../dtos/ClientUsersAdminDto";
import { PagedResultDto } from "../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedResultDto";
import { ClientUsersAdminFiltersDto } from "../dtos/ClientUsersAdminFiltersDto";
import { PagedSearchDto } from "../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedSearchDto";

@Injectable({providedIn: 'root'})
export class ApiClientAdminUsers {
  constructor(private _httpApiClient: HttpApiClient) {
    // Empty constructor
  }

  create(
    clientUsersAdminDto: ClientUsersAdminDto,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<ClientUsersAdminDto> {
    return this._httpApiClient.post("/client-admin/client-users-admin", clientUsersAdminDto, httpApiRequestOptions);
  }

  edit(
    clientUsersAdminDto: ClientUsersAdminDto,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<ClientUsersAdminDto> {
    return this._httpApiClient.put("/client-admin/client-users-admin", clientUsersAdminDto, httpApiRequestOptions);
  }

  getById(
    id: string,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<ClientUsersAdminDto> {
    return this._httpApiClient.get("/client-admin/client-users-admin/" + id, httpApiRequestOptions);
  }

  getPaged(
    filters: PagedSearchDto<ClientUsersAdminFiltersDto>,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<PagedResultDto<ClientUsersAdminDto>> {
    return this._httpApiClient.post("/client-admin/client-users-admin/paged", filters, httpApiRequestOptions);
  }

  delete(
    id: string,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<ClientUsersAdminDto> {
    return this._httpApiClient.delete("/client-admin/client-users-admin/" + id, httpApiRequestOptions);
  }

  getAllForUser(
    id: string,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<ClientUsersAdminDto[]> {
    return this._httpApiClient.get("/client-admin/client-users-admin/get-all-for-user/" + id, httpApiRequestOptions);
  }

}
